import { CheckoutAbTestMetricToOptimize } from "@redotech/redo-model/checkouts/checkout-ab-test-builder";
import { CheckoutExperienceZodArraySchema } from "@redotech/redo-model/integration/redo-in-shipping/ris";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const treatmentSchema = z.object({
  id: zExt.objectId(),
  name: z.string(),
  isSpecialExistingExperienceTreatment: z.boolean(),
  allCheckoutExperiences: CheckoutExperienceZodArraySchema,
});
export type GetCheckoutSplitDetailsTreatment = z.infer<typeof treatmentSchema>;

export const getCheckoutSplitDetails = {
  name: "getCheckoutSplitDetails" as const,
  input: z.object({ splitId: zExt.objectId() }),
  output: z.object({
    name: z.string(),
    description: z.string(),
    metricToOptimize: z.enum(CheckoutAbTestMetricToOptimize),
    status: z.enum(["in_progress", "concluded", "scheduled"]),
    controlTreatment: treatmentSchema,
    variantTreatments: z.array(treatmentSchema),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
  }),
};
export type GetCheckoutSplitDetailsOutput = z.infer<
  typeof getCheckoutSplitDetails.output
>;
